import { received } from '../inbox/inboxRules';
import { eventLabel } from './orderLabels';
import type { OrderEvent } from '../../core/types/adminRequests';

/** Wat er met een bestelling gebeurde, oudste bovenaan. Alleen tonen: de server schrijft de tijdlijn. */
export function OrderTimeline({
  events
}: {
  events: OrderEvent[];
}) {
  if (events.length === 0) return <p className="text-[13px] text-muted" data-id="element-3650" data-mp="1v4qcimadnpe6">Nog niets gebeurd.</p>;
  return <ol className="relative space-y-4 border-l border-line pl-4" data-id="element-3651" data-mp="17fnmor5laq8l">
      {events.map((e, i) => <li key={`${e.at}-${e.event}-${i}`} className="relative" data-id="element-3652" data-mp="13e2ehj40304q" data-mpi={i}>
          <span className={`absolute -left-[21px] top-1.5 h-2.5 w-2.5 rounded-full border-2 border-white ${i === events.length - 1 ? 'bg-clay' : 'bg-line'}`} aria-hidden="true" data-id="element-3653" data-mp="1hcij94iaygk8" />
          <p className="text-[14px] text-ink" data-id="element-3654" data-mp="2srfkrdvoay8h">{eventLabel[e.event]}</p>
          <p className="text-[12px] text-muted" data-id="element-3655" data-mp="2sts2bpxir6l0">
            {received(e.at)}
            {e.note && ` · ${e.note}`}
          </p>
        </li>)}
    </ol>;
}